export default function NotificationDot({ title, color }) {
  return (
    <div>
      <div
        className="mx-auto max-h-[14px] min-h-[14px] min-w-[14px] max-w-[14px] rounded-full pt-1"
        style={{ backgroundColor: color }}
      />
      <span className="text-sm font-medium text-neutral-4">{title}</span>
    </div>
  )
}
